<script>
  import { modal, tabs, tab } from 'vue-strap';
  import dropzone from 'vue2-dropzone';
  import tiposAceitos from '~js/tipos-arquivos-upload';
  import contratoServico from '~modulos/fornecedor/servico';

  export default {
    components: { modal, tabs, tab, dropzone },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      id: {
        required: true,
      },
      mostrarDropzone: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        arquivos: [],
        carregando: true,
        possuiArquivo: false,
        dropzoneOptions: {
          url: this.url(),
          maxFilesize: (this.$storage.configuracao().limiteArquivoWeb > 0 ? (this.$storage.configuracao().limiteArquivoWeb / 1024 / 1024).toFixed(2) : 999999999),
          headers: { "Authorization": this.$storage.token() },
          addRemoveLinks: false,
          createImageThumbnails: true,
          acceptedFiles: tiposAceitos.join(),
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Arraste os arquivos aqui ou clique para seleciona-los.",
          dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
          dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo é de: {{maxFilesize}}MiB.",
          dictInvalidFileType: "O envio desse tipo de arquivo não é permitido.",
          dictResponseError: "Server responded with {{statusCode}} code.",
          dictCancelUpload: "Cancelar",
          dictCancelUploadConfirmation: "Deseja realmente cancelar o envio do arquivo?",
          dictRemoveFile: "Remover",
        }
      }
    },
    methods: {
      url() {
        return `${window.location.origin}/api/contratos/${this.id}/arquivos`;
      },
      lista() {
        this.carregando = false;
        const promise = contratoServico.arquivos(this.id);

        promise
          .then(arquivos => {
            this.arquivos = arquivos;
            this.possuiArquivo = (arquivos.length > 0);
            this.carregando = false;
          });
      },
      download(arquivo) {
        const promise = contratoServico.download(this.id, this.nomeArquivo(arquivo));

        promise
          .then(arquivo => {
            arquivo.download();
          });
      },
      carregar() {
        this.lista();
        this.dropzoneOptions.url = this.url();
        //this.mostrarDropzone = true;
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
    },
    mounted() {

    }
  }
</script>

<template>
  <div>

    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="mostrarDropzone = false, arquivos = [], $emit('fechado')"
           @opened="carregar"
           :large="true">
      <div slot="modal-header" class="modal-header">Arquivos do contrato número #{{ id }}</div>

      <tabs :nav-style="'tabs'" :justified="true">
        <tab header="Arquivos">

          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Nome do arquivo</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="arquivo in arquivos">
                  <td>{{ nomeArquivo(arquivo.replace("_PROTOCOLO", "")) }}</td>
                  <td class="action">
                    <button type="button"
                            class="btn btn-default btn-xs"
                            @click="download(arquivo)">
                      <i class="fa fa-download"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="arquivos.length === 0 && !carregando">
                  <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                </tr>
                <tr v-show="carregando">
                  <td colspan="2">
                    <i class='fa fa-spinner fa-pulse'></i> Carregando...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </tab>
        <tab header="Adicionar arquivos" v-if="mostrarDropzone">
          <template >
            <dropzone ref="dropzone"
                      :options="dropzoneOptions"
                      id="dropzone"
                      @vdropzone-success-multiple="lista"
                      @vdropzone-success="lista">
            </dropzone>
          </template>
        </tab>
      </tabs>

      <div slot="modal-footer" class="modal-footer">
        <button type="button"
                class="btn btn-default"
                @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalArquivosContrato.vue